import React, { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import CoAdminSidebar from '../components/coadmin/CoAdminSidebar';
import AuthContext from '../context/AuthContext';
import { Menu } from 'lucide-react';

const CoAdminDashboard = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const { user } = useContext(AuthContext);

    return (
        <div className="min-h-screen bg-slate-50 flex font-sans text-slate-800">
            {/* Sidebar Overlay for Mobile */}
            {isSidebarOpen && (
                <div
                    className="fixed inset-0 bg-slate-900/50 backdrop-blur-xs z-40 md:hidden"
                    onClick={() => setSidebarOpen(false)}
                ></div>
            )}

            {/* Sidebar Navigation */}
            <CoAdminSidebar isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col min-w-0 transition-all duration-300">
                {/* Flat Header */}
                <header className="bg-white border-b border-slate-200/80 sticky top-0 z-30">
                    <div className="px-4 sm:px-6 lg:px-8 py-3.5 flex items-center justify-between">
                        {/* Mobile Menu Toggle */}
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => setSidebarOpen(true)}
                                className="md:hidden p-2 rounded-xl text-slate-500 hover:bg-slate-50 hover:text-slate-800 transition-colors focus:outline-none"
                                aria-label="Open menu"
                            >
                                <Menu className="w-5 h-5" />
                            </button>
                            <span className="hidden md:inline-flex items-center px-2.5 py-1 rounded-full bg-teal-50 text-teal-750 font-bold text-[10px] border border-teal-100 uppercase tracking-wider">
                                Coordinator Workspace Active
                            </span>
                        </div>

                        {/* Profile Info */}
                        <div className="flex items-center gap-4">
                            <div className="flex items-center gap-3 pl-4">
                                <div className="hidden sm:block text-right">
                                    <p className="text-xs font-bold text-slate-800 leading-none">
                                        {user?.name || 'Coordinator'}
                                    </p>
                                    <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mt-1">
                                        {user?.role || 'Co-Admin'}
                                    </p>
                                </div>
                                <div className="flex items-center justify-center w-9 h-9 rounded-full bg-teal-600 text-white font-bold text-sm shadow-sm">
                                    {user?.name?.charAt(0)?.toUpperCase() || 'C'}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <main className="flex-1 p-4 sm:p-6 md:p-8 overflow-y-auto">
                    <div className="max-w-7xl mx-auto w-full">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default CoAdminDashboard;